<template>
    <div>
        <button
            @click="openModal"
            type="button"
            class="text-blue hover:underline"
        >
            {{button ?? $t('LEARN_MORE')}}
        </button>

        <base-modal
            @modalClose="showModal = false"
            :show-modal="showModal"
            :modal-size="modalSize"
        >
            <template v-slot:content>
                <iframe v-if="vimeo"
                    :src="vimeo"
                    data-progress="true"
                    frameborder="0"
                    autoplay="1"
                    data-seek="true"
                    webkitallowfullscreen="true"
                    mozallowfullscreen="true"
                    allowfullscreen="true"
                    height="550"
                    width="962"
                    data-bounce="true"
                    autopause="0"
                    data-ready="true"

                    class="max-w-full"
                ></iframe>

                <div
                    v-if="text"
                    class="cz3__info-modal__text"
                >
                    <div v-html="text"></div>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<style>
    #cz3 .cz3__info-modal__text h3 {
        @apply mb-4 font-semibold font-oceanside;
    }

    #cz3 .cz3__info-modal__text a {
        @apply text-blue underline;
    }
</style>

<script>
    import BaseModal from './BaseModal.vue';

    export default {
        components: {
            BaseModal,
        },

        props: {
            button: String,
            vimeo: {
                type: String,
            },
            text: {
                type: String,
            },
        },

        data() {
            return {
                showModal: false,
            };
        },

        computed: {
            modalSize() {
                if (this.vimeo) {
                    return 'large';
                }

                return 'small';
            },
        },

        methods: {
            openModal() {
                this.showModal = true;
            },
        },
    };
</script>
